import {setArchivedProjectList, setDeletedProjectList, setProjectList} from "../actions";
import Facade from "../Facade";

export default function runRefreshDeletedProjectList ( dispatch )
{
  //刷新
  Facade.gw.getRecycleProject((list) => {
    dispatch(setDeletedProjectList(list));
  });
}